export default __webpack_public_path__ + "static/media/38t.78abf330.jpg";